import Retainers from 'components/retainers'
import { appliesMeta } from '@/utils/functions/applies-meta'

export default appliesMeta({
    requiresAuth: true,
    template: 'chameleon'
  },
  [
    {
      path: '/retainers',
      component: Retainers.Index,
      name: 'retainers.index',
    },
    {
      path: '/retainers/:retainer_id',
      component: Retainers.Show,
      name: 'retainers.show',
      children: [
        {
          path: 'overview',
          component: Retainers.Overview,
            name: 'retainers.overview',
        },
        {
          path: 'invoices',
          component: Retainers.Invoices,
            name: 'retainers.invoices',
        }
      ]
    },
  ])
